import React, { useContext,useEffect, useMemo, useState } from "react";
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import 'react-data-table-component-extensions/dist/index.css';
import {
    useSortBy,
    useTable,
    usePagination,
    useGlobalFilter,
} from "react-table";
import axios from "axios";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { CSVLink } from "react-csv";
import { useHistory, useLocation } from "react-router-dom";
import Select, {createFilter} from "react-select";
import {
    getDefaultUserViewAllSettingsTerminalApi,
    getUserViewAllSettingsTerminalApi, getViewSettingsTerminalRHSApi,
    TerminalDataTableListMgmtApi,
    TerminalLocationDataTableViewApi,
    TerminalMgmtApi
} from "../Api";
import {terminalListContext} from "../App";
import CustomOption from "../Utils/CustomOption";
import CustomMenuList from "../Utils/CustomMenuList";


function TerminalDatatable() {
    const {terminalList:terminalOptions, setTerminalList:setTerminalOptions}  = useContext(terminalListContext);
    const loggedUserStorage = sessionStorage.getItem('loggedUserStorage');
    const history = useHistory();
    const location = useLocation();
    const searchParams = new URLSearchParams();
    //const [terminalOptions, setTerminalOptions] = useState([]);
    const [locationOption, setLocationOption] = useState([]);
    const [selectedTerminal, setSelectedTerminal] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState([]);
    const [settingOptions,setSettingOptions] = useState([]);
    const [selectedSetting,setSelectedSetting] = useState([]);
    const [perPage, setPerPage] = useState(100);
    const [totalRecords, setTotalRecords] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [pending, setPending] = React.useState(true);
    const [hideDirector, setHideDirector] = useState(false);




    //  Internally, customStyles will deep merges your customStyles with the default styling.
    const tableStyles = {
        rows: {
            style: {
                minHeight: '30px',
                fontSize: '10px',// override the row height
            },
        },
        cells: {
            style: {
                paddingLeft: '8px',
                paddingRight: '8px',
                fontSize: '10px',
                wordBreak: 'break-word',
            },
            draggingStyle: {},
        },
        dataTableExt: {
            style: {
                Width:'40px',
            },
        },
    };

    const handleTerminalTableRowClick = (data) => {
        history.push({
            pathname: "/termManagement/terMinalDetails",
            search: `terminalID=${data}`,
        });
    };

    /**Custom table code*/
    const datacolumns = [
        {
            name: 'Error ',
            width: "70px",
            selector: row => row.errorStatusIcon.includes("GOOD")?<img
                src="/assets/images/icons/shield-green.png"
                height="13"
                width="13"
            />:<img
                src="/assets/images/icons/shield-red.png"
                height="13"
                width="13"
            />,
            fixedHeader:true,
        },
        {
            name: 'Cash ',
            width: "70px",
            selector: row => row.cashStatusIcon.includes("CASH OUT")?<img
                src="/assets/images/icons/shield-green.png"
                height="13"
                width="13"
            />:<img
                src="/assets/images/icons/shield-red.png"
                height="13"
                width="13"
            />,
        },
        {
            name: 'Terminal',
            font:'10px',
            selector: row => (
                <h8
                    style={{
                        color: "blue",
                        cursor: "pointer",
                        textDecoration: "underline",
                        fontWeight: "normal",
                    }}
                    onClick={() => handleTerminalTableRowClick(row.terminalID)}
                >
                    {row.terminalID}
                </h8>
            ),
            sortable: true,
        },
        {
            name: 'Location ',
            selector: row => row.locationName,
            sortable: true,
        },
        {
            name: 'Address ',
            selector: row => row.address,
            sortable: true,
        },
        {
            name: 'Last Txn Data ',
            selector: row => row.lastTransTime,
            sortable: true,
        },
        {
            name: 'TimeZone ',
            selector: row => row.timeZoneName,
            sortable: true,
        },
        {
            name: 'Serial No ',
            selector: row => row.serialNum,
            sortable: true,
        },
        {
            name: 'Routing Code ',
            selector: row => row.modelID,
            sortable: true,
            omit: {hideDirector},
        },
        {
            name: 'Emulation ',
            selector: row => row.emulationDesc,
            sortable: true,
            omit: {hideDirector},
        },
    ];


    /**End of Custom Data table*/
    const columns = useMemo(
        () => [
            {
                Header: "Error",
                accessor: "",
                Cell: (props) => {
                    return (
                        <img
                            src="/assets/images/icons/shield-grey.png"
                            height="16"
                            width="16"
                        />
                    );
                },
            },
            {
                Header: "Cash",
                accessor: "",
                Cell: (props) => {
                    return (
                        <img
                            src="/assets/images/icons/shield-red.png"
                            height="16"
                            width="16"
                        />
                    );
                },
            },
            {
                Header: "Terminal Id",
                accessor: "terminalID",
                Cell: (props) => (
                    <h6
                        style={{
                            color: "blue",
                            cursor: "pointer",
                            textDecoration: "underline",
                            fontWeight: "normal",
                        }}
                        onClick={() => handleTerminalTableRowClick(props.value)}
                    >
                        {props.value}
                    </h6>
                ),
            },
            {
                Header: "Location Name",
                accessor: "locationName",
            },
            {
                Header: "Address",
                accessor: "address",
            },
            {
                Header: "Last Trans Data",
                accessor: "lastTransData",
                Cell: ({ value }) => {
                    return Math.random().toString();
                },
            },
            {
                Header: "Last Trans Time",
                accessor: "lastTransTime",
            },
            {
                Header: "Time Zone Name",
                accessor: "timeZoneName",
            },
            {
                Header: "Cassette 1 Current Count",
                accessor: "",
            },
            {
                Header: "Serial Number",
                accessor: "SerialNum",
            },
            {
                Header: "Routing Code",
                accessor: "RoutingCode",
            },
            {
                Header: "Emulation Description",
                accessor: "LoadAsEmulationDesc",
            }
        ],
        []
    );

    const handleSettingsSelection = async (e) => {
        setSelectedSetting(e)
    };
    useEffect(() => {
        console.log(" change cols on changes ",selectedSetting)
    }, [selectedSetting]);
    // const data = useMemo(()=>[],[])
    const [data, setData] = useState([]);
    useEffect(() => {
        const fetchResults = async () => {
            let result = await axios.get(`${TerminalMgmtApi}?id=${loggedUserStorage}&searchCriteria=""&lastTxn=10&pageSize=${perPage}&currentPage=${currentPage}&sortColumn=TerminalID&sortOrder=DESC`,{
                mode: 'no-cors' // 'cors' by default
            });
            console.log("END OF DATATABLE RETRIEVE");
            let resultTerminal = await axios.get(`${TerminalDataTableListMgmtApi}?id=${loggedUserStorage}&parentUserId=${loggedUserStorage}`,{
                mode: 'no-cors' // 'cors' by default
            });

            console.log("END OF TERMINAL RETRIEVE");
            let resultLocation = await axios.get(`${TerminalLocationDataTableViewApi}?id=${loggedUserStorage}&parentUserId=${loggedUserStorage}`,{
                mode: 'no-cors' // 'cors' by default
            });
            console.log("END OF LOCATION RETRIEVE");
            let resultSettings = await axios.get(`${getUserViewAllSettingsTerminalApi}?paramUserID=${loggedUserStorage}&paramUserViewID=-1&paramLoadAtStartUp=-1`);
            console.log("END OF SETTINGS RETRIEVE");
            let resultDefaultViewSettings = await axios.get(`${getDefaultUserViewAllSettingsTerminalApi}?paramUserID=${loggedUserStorage}`);
            console.log("END OF DEFAULT SETTINGS RETRIEVE");


            setData(result.data.response);



            setTerminalOptions(resultTerminal?.data?.response);
            setTotalRecords(resultTerminal?.data?.response?.length);
            setLocationOption(resultLocation?.data);

            setSelectedTerminal({
                label: resultTerminal?.data.response?.[0]?.terminalID,
                value: resultTerminal?.data.response?.[0]?.terminalID,
            });
            setSelectedLocation({
                label: resultLocation?.data?.[0]?.locationName,
                value: resultLocation?.data?.[0]?.locationName,
            });

            resultSettings?.data?.response.map((item, index) =>
                setSettingOptions((old) => [
                    ...old,
                    { label: item?.userViewName, value: item?.userViewID },
                ])
            );
            resultDefaultViewSettings?.data?.response.map((item, index) =>
                setSelectedSetting((old) => [
                    ...old,
                    { label: item?.userViewName, value: item?.userViewID },
                ])
            );
            //setSelectedSetting({label:"setting1",value:'setting2'})
            setPending(false);
        };
        fetchResults();

        return () => {
            //setTerminalOptions([]);
            setLocationOption([]);
        };
    }, [currentPage]);

    const exportPDF = () => {
        const unit = "pt";
        const size = "A4";
        const orientation = "portrait";

        const marginLeft = 40;
        const doc = new jsPDF(orientation, unit, size);

        doc.setFontSize(15);

        const title = "Terminal Details";
        const headers = [["terminalID", "locationName"]];

        const pdata = data?.map((elt) => [...Object.values(elt)]);

        let content = {
            startY: 50,
            head: headers,
            body: pdata,
        };

        doc.text(title, marginLeft, 40);
        doc.autoTable(content);
        doc.save("report.pdf");
    };

    function Table({ columns, data }) {
        const {
            getTableProps,
            getTableBodyProps,
            headerGroups,
            page,
            nextPage,
            previousPage,
            canNextPage,
            canPreviousPage,
            setGlobalFilter,
            state: { pageIndex, pageSize, globalFilter },
            prepareRow,
        } = useTable(
            {
                columns,
                data,
                initialState: { pageSize: 2 },
            },
            useGlobalFilter,
            useSortBy,
            usePagination
        );



        const handleSelectedTerminal = () => {
            console.log(selectedTerminal, "selected terminal");
            history.push({
                pathname: "/termManagement/terMinalDetails",
                search: `terminalID=${selectedTerminal?.value}`,
            });
        };
        return (
            <>
                <div className="row mt-3" style={{fontSize:"10px"}}>
                    <div className="col-md-4">
                        <div className="form-group" >
                            <label className="control-label">Jump to Terminal ID:</label>
                            <div className="input-group mb-3">
                                <Select
                                    options={terminalOptions}
                                    filterOption={createFilter({ ignoreAccents: false })}
                                    captureMenuScroll={false}
                                    classNamePrefix="custom-select"
                                    components={{ Option: CustomOption, MenuList: CustomMenuList }}
                                    onChange={(e) => setSelectedTerminal(e)}
                                    value={selectedTerminal}
                                    styles={{
                                        container: (provided) => ({
                                            ...provided,
                                            flex: 1,
                                        }),
                                    }}
                                />
                                <div className="input-group-append">
                  <span
                      className="input-group-text"
                      id="basic-addon2"
                      role="button"
                      onClick={handleSelectedTerminal}
                  >
                    Go
                  </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label className="control-label">Jump to Location:</label>
                            <div className="input-group mb-3">
                                <Select
                                    options={locationOption}
                                    filterOption={createFilter({ ignoreAccents: false })}
                                    captureMenuScroll={false}
                                    classNamePrefix="custom-select"
                                    components={{ Option: CustomOption, MenuList: CustomMenuList }}
                                    onChange={(e) => setSelectedLocation(e)}
                                    value={selectedLocation}
                                    styles={{
                                        container: (provided) => ({
                                            ...provided,
                                            flex: 1,
                                        }),
                                    }}
                                />
                                <div className="input-group-append">
                  <span
                      className="input-group-text"
                      id="basic-addon2"
                      role="button"
                      onClick={handleSelectedTerminal}
                  >
                    Go
                  </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label className="control-label">
                                Select pre-defined view setting to view terminals:
                            </label>
                            <div className="input-group mb-3">
                                <Select
                                    options={settingOptions}
                                    filterOption={createFilter({ ignoreAccents: false })}
                                    captureMenuScroll={false}
                                    classNamePrefix="custom-select"
                                    components={{ Option: CustomOption, MenuList: CustomMenuList }}
                                    onChange={handleSettingsSelection}
                                    value={selectedSetting}
                                    styles={{
                                        container: (provided) => ({
                                            ...provided,
                                            flex: 1,
                                        }),
                                    }}
                                />
                                <div className="input-group-append">
                  <span
                      className="input-group-text"
                      id="basic-addon2"
                      role="button"
                      onClick={handleSelectedTerminal}
                  >
                    Set As Default
                  </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </>
        );
    }


    if(pending){
        return <div className="spinner-container">
            <div className="loading-spinner">
            </div>
        </div>
    }
    return (
        <div className="tab-pane" id="tb_terminal_mgmt" role="tabpanel">
            <div className="row">
                <div className="col-md-12">
                    <div className="form-group">
                        {<Table columns={columns} data={data}  />}
                        {/*<button type="button" className="btn btn-light" style={{position: "absolute",marginLeft: "90%",marginTop: "5px"}}>
                      <i className="bi bi-file-earmark-excel"></i>
                      <CSVLink
                          data={data}
                          style={{color: "inherit", textDecoration: "inherit"}}
                      >
                          Excel
                      </CSVLink>
                  </button>*/}
                        <DataTableExtensions
                            columns={datacolumns}
                            data={data}
                            print={false}
                            export={false}
                            customStyles={tableStyles}
                        >

                            <DataTable
                                columns={datacolumns}
                                data={data}
                                noHeader
                                pagination
                                highlightOnHover
                                pointerOnHover
                                paginationServer
                                paginationTotalRows={totalRecords}
                                paginationPerPage={perPage}
                                paginationComponentOptions={{
                                    noRowsPerPage: true
                                }}
                                progressPending={pending}
                                onChangePage={page => setCurrentPage(page)}
                                customStyles={tableStyles}
                            />
                        </DataTableExtensions>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TerminalDatatable;
